import ManageAccountModal from './ManageAccountModal';
import PaymentMethods from './payment-methods';

export default {
  ManageAccountModal,
  PaymentMethods,
};
